'use strict';

var implementation = require('./implementation');

module.exports = function getPolyfill() {
	return typeof Object.is === 'function' ? Object.is : implementation;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/object-is/polyfill.js
 ** module id = 1419
 ** module chunks = 0
 **/